<template>
    <v-footer id="footer" :padless="true">
      <v-card dark flat tile width="100%" class="text-left">
        <v-card-text>
          <v-container>
            <v-row>
              
              <v-col sm="3" cols="12" id="footer-logo-container">
                <img src="../assets/thon_logo.png" width="100%" alt="THON" />
              </v-col>
              <v-col sm="3" offset-sm="1" cols="12">
                <div class="text-button">
                  External sites
                </div>
                <div class="text-body1">
                  <ul class="footer-list">
                    <li>
                      <a href="https://think.thon.org">THINK</a>
                    </li>
                    <li>
                      <a href="https://dash.thon.org">Dash</a>
                    </li>
                  </ul>
                </div>
              </v-col>
              <v-col sm="5" cols="12">
                <div class="text-button">
                  Report a problem
                </div>

                <div class="text-body1">
                  <ul class="footer-list">
                    <li>
                      Quiz-related issues
                      <br /> 
                      <a href="mailto:special.projects@thon.org">special.projects@thon.org</a>
                    </li>
                    <li>
                      THON Office Phone Number
                      <br /> 
                      <a href="tel:1-800-392-8466">1-800-392-THON</a>
                    </li>
                  </ul>
                </div>

              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-footer>
</template>

<script>
export default {
  methods: {
    isMobile() {
      if(window.innerWidth <= 760) {
          return true;
      }
      else {
          return false;
      }
    }
  }
}
</script>

<style lang="scss">
#footer {
  height: 5rem;
  position: absolute;
  width: 100%;
  bottom: 0;
  z-index: 10;

  @media only screen and (max-width: 900px) {
    & {
      position: relative;
    }
  }

  & .text-button {
    line-height: 1.375rem;
    margin-bottom: 1rem;
  }
}

#footer-logo-container {
  text-align: center;
  padding: 1rem;

  & img {
    max-width: 225px;
    margin-bottom: 2rem;
  }
}

.footer-list {
  list-style: none;
  padding-left: 0 !important;
  color: inherit;

  & li {
    margin-bottom: .75rem;

    & a {
      font-weight: 600;
      color: #fff;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

</style>